import React, { useRef } from "react";
import { Input, Popover } from "antd";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getInitials } from "../../../libs/utils";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import SimpleLoader from "../../general/loader";
import InfiniteScroll from "react-infinite-scroller";
import { loadRecipients } from "../../../store/actions/ask/recipients";
import Spinner from "../../general/spinner";

const AskBuilderRecipients = props => {
  const {
    recipients,
    readOnly,
    onRecipientsChange,
    isShared,
    isForDots,
    pageRef
  } = props;

  const recipientsRedux = useSelector(state => state.recipient);
  const [showPopover, setShowPopover] = useState("");

  // dal 3 carattere in poi
  const [changedChar, setChangedChar] = useState(null);
  const [startSearch, setstartSearch] = useState(false);

  const dispatch = useDispatch();

  const intl = useIntl();

  const timerToSearching = useRef(null); // now you can pass timer to another component

  useEffect(() => {
    document.addEventListener("click", checkClick);
    dispatch(loadRecipients());

    return () => {
      document.removeEventListener("click", checkClick);
    };
  }, []);

  useEffect(() => {
    // Se cambia un carattere entro 500 ms pulisco il timer
    clearInterval(timerToSearching.current);

    timerToSearching.current = setInterval(() => setstartSearch(true), 500);

    return () => {
      clearInterval(timerToSearching.current);
    };
  }, [changedChar]);

  useEffect(() => {
    if (
      startSearch &&
      changedChar &&
      changedChar.length > 3 &&
      !recipientsRedux.status.started &&
      recipientsRedux.status.ended
    ) {
      dispatch(loadRecipients(changedChar,
        recipientsRedux.preSearchedCompany));
    }
    if (
      startSearch &&
      changedChar !== null &&
      changedChar.length === 0 &&
      !recipientsRedux.status.started &&
      recipientsRedux.status.ended
    ) {
      dispatch(loadRecipients());
    }
  }, [startSearch]);

  const recipientsTip = useIntl().formatMessage({ id: "ask.pages.edit.recipientsTip" });

  const checkClick = event => {
    if (event.target.id === "askEdit-recipients-input") {
      setShowPopover(true);
    } else {
      if (event.target.id.indexOf("askEdit-recipient-") === -1) {
        setShowPopover(false);
      }
    }
  };

  const onSearch = e => {
    // setSearchValue(e.target.value || "");
    const changedVal = e.target.value;
    setChangedChar(changedVal);
    setstartSearch(false);
  };

  const onChangeSelection = value => {
    let nRecipients = [...recipients];
    if (!recipients.find(x => x.uuid === value.uuid)) {
      nRecipients.push(value);
    }
    onRecipientsChange(nRecipients);
    setShowPopover(false);
  };

  const onRemoveSelection = value => {
    let nRecipients = [];
    recipients.map(item => {
      if (item !== value) {
        nRecipients.push(item);
      }
      return null;
    });
    onRecipientsChange(nRecipients);
    setShowPopover(false);
  };

  const renderRecipients = () => {
    let items = [];
    if (recipientsRedux.recipients) {
      recipientsRedux.recipients.map(recipient => {
        if (recipient.accountant) {
          return null;
        }
        return items.push(<div
          key={"askEdit-recipient-" + recipient.id}
          name={"askEdit-recipient-" + recipient.id}
          id={"askEdit-recipient-" + recipient.id}
          className={
            "recipient optionLiAutoComplete" +
              (recipients.indexOf(recipient.uuid) > -1 ? " disabled" : "")
          }
          onClick={() => onChangeSelection(recipient)}
        >
          <div
            id={"askEdit-recipient-rootDescription-" + recipient.id}
            className="rootCompanyDescription"
          >
            <div
              id={"askEdit-recipient-roundUser-" + recipient.id}
              className="roundUser"
              style={{ marginRight: 5 }}
            >
              <span>{getInitials(recipient.ragioneSociale)}</span>
            </div>
            <div
              id={"askEdit-recipient-description-" + recipient.id}
              className="companyDescription"
            >
              {recipient.ragioneSociale}
            </div>
          </div>
          <div
            id={"askEdit-recipient-cf-" + recipient.id}
            className="companyCF txtSmall"
          >
            <FormattedMessage id="generic.fiscalCodeAbbreviation" /> {recipient.codiceFiscale}
          </div>
        </div>);
      });
    }

    return (
      <InfiniteScroll
        loader={<SimpleLoader />}
        hasMore={recipientsRedux.hasMoreItems}
        pageStart={0}
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => pageRef.current}
        loadMore={() => {
          if (
            recipientsRedux.status.ended &&
            !recipientsRedux.status.started &&
            recipientsRedux.hasMoreItems
          ) {
            dispatch(loadRecipients(
              changedChar > 3 || changedChar === "" ? changedChar : "",
              recipientsRedux.recipients,
              recipientsRedux.page + 1
            ));
          }
        }}
      >
        <div id="askEdit-recipients-list" className="recipients-list">
          {items}
        </div>
      </InfiniteScroll>
    );
  };

  const renderSummary = () => {
    let items = [];
    recipients.map(recipientItem => {
      let myRecipient = recipientsRedux.recipients.find(x => x.uuid === recipientItem.uuid);
      if (recipientItem.codiceFiscale && !myRecipient) {
        myRecipient = recipientItem;
      }
      return (
        myRecipient &&
        items.push(<div
          key={"selected-recipient-" + recipientItem.uuid}
          className="selected-recipient"
        >
          <div className="recipient-description-container">
            <div className="roundUser" style={{ marginRight: 5 }}>
              <span>{getInitials(myRecipient.ragioneSociale)}</span>
            </div>
            <div className="recipient-description">
              {myRecipient.ragioneSociale}
            </div>
          </div>
          <div className="recipient-cf txtSmall">
            <FormattedMessage id="generic.fiscalCodeAbbreviation" /> {myRecipient.codiceFiscale}
          </div>
          {!readOnly && (
            <div
              className="recipient-remove"
              onClick={() => onRemoveSelection(recipientItem)}
            >
              <FontAwesomeIcon
                icon={["fal", "trash-alt"]}
                style={{ fontSize: 16, color: "#d82829" }}
              />
            </div>
          )}
        </div>)
      );
    });
    return items;
  };

  if (readOnly) {
    return (
      <div className="askEdit-search-recipient-summary">
        <div className="askEdit-preview-recipients"><FormattedMessage id="ask.builder.recipients" /></div>
        {renderSummary()}
      </div>
    );
  }

  return recipientsRedux.status.started ? (
    <Spinner size="large" />
  ) : (
    <React.Fragment>
      <div className="askList-search askEdit-search-recipient">
        <Popover
          trigger="click"
          visible={showPopover}
          placement="bottom"
          overlayClassName="askEdit-search-recipient-popover"
          content={renderRecipients()}
        >
          <Input
            id="askEdit-recipients-input"
            placeholder={intl.formatMessage({ id: "ask.builder.usersPlaceholder" })}
            className="askEdit-search-recipient-input"
            value={changedChar}
            onChange={onSearch}
            autoComplete={"off"}
            onFocus={() => {
              setShowPopover(true);
            }}
            // onBlur={this.onBlurInput.bind(this)}
            suffix={
              <Button style={{ marginRight: -8 }}>
                <FontAwesomeIcon icon={["far", "search"]} />
              </Button>
            }
          />
        </Popover>
      </div>
      {(isShared || isForDots) && (
        <div className="askEdit-search-recipient-tip">
          {recipientsTip}
        </div>
      )}
      <div className="askEdit-search-recipient-summary">{renderSummary()}</div>
    </React.Fragment>
  );
};

export default AskBuilderRecipients;
